// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin {
  min-height: 80vh;
  overflow: auto;
}
.admin::-webkit-scrollbar {
  width: 0.7em;
  height: 0.7em;
}
.admin::-webkit-scrollbar-thumb {
  background: #3b00f8;
}
.admin::-webkit-scrollbar-track {
  background: #9d80fc;
}
@media (max-width: 600px) {
  .admin::-webkit-scrollbar {
    width: 0em;
    height: 0em;
  }
  .admin::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .admin::-webkit-scrollbar-track {
    background: white;
  }
}
.admin .admin_sections {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2vh;
  width: 100%;
  margin: 1vh auto;
}
.admin .admin_sections .admin_section {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  width: 95vw;
  border-radius: 5px;
}
.admin .admin_sections .admin_section .create_section,
.admin .admin_sections .admin_section .update_section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  height: 22vh;
  width: 42vw;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  background-color: #ffe169;
  border-radius: 5px;
  padding: 10px;
}
.admin .admin_sections .admin_section .create_section h2,
.admin .admin_sections .admin_section .update_section h2 {
  margin: 0 auto;
  color: #151042;
  text-transform: uppercase;
}
.admin .admin_sections .admin_section .create_section input,
.admin .admin_sections .admin_section .create_section select,
.admin .admin_sections .admin_section .update_section input,
.admin .admin_sections .admin_section .update_section select {
  box-sizing: border-box;
  height: 4.5vh;
  width: 80%;
  border-radius: 5px;
  border: none;
  padding: 0 5px;
  color: #151042;
  font-size: 1rem;
}
.admin .admin_sections .admin_section .create_section button,
.admin .admin_sections .admin_section .update_section button {
  width: 80%;
  background-color: #151042;
  font-size: 1.1rem;
}
.admin .admin_sections .admin_section .create_section button:hover,
.admin .admin_sections .admin_section .update_section button:hover {
  background-color: #3b00f8;
}
@media (max-width: 1000px) {
  .admin .admin_sections .admin_section .create_section,
  .admin .admin_sections .admin_section .update_section {
    width: 95vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/admin.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,gBCgBU;EDfV,cAAA;AADJ;AC4DI;EACI,YD3DgB;EC4DhB,aD5DgB;AAExB;AC6DI;EACI,mBAxDO;ADHf;AC8DI;EACI,mBAbe;AD/CvB;AAPI;ECyDA;IACI,UDzDoB;IC0DpB,WD1DoB;EAW1B;ECkDE;IACI,gBA9DA;EDcN;ECmDE;IACI,iBAbe;EDpCrB;AACF;AAfI;ECmBA,aAAA;EACA,uBDnBkB;ECoBlB,mBDpB0B;ECqB1B,sBDrBkC;ECsBlC,QDtB0C;EACtC,WAAA;EACA,gBAAA;AAqBR;AApBQ;ECeJ,aAAA;EACA,6BDfsB;ECgBtB,mBDhBoC;ECiBpC,mBDjB4C;ECkB5C,SDlBiD;EACzC,eAAA;EACA,WAAA;EACA,kBAAA;AA0BZ;AAzBY;;ECUR,aAAA;EACA,uBDT0B;ECU1B,mBDVkC;ECWlC,sBDX0C;ECY1C,SDZkD;EACtC,YAAA;EACA,WAAA;EACA,2CAAA;EACA,yBCVC;EDWD,kBAAA;EACA,aAAA;AA+BhB;AA7BgB;;EACI,cAAA;EACA,cCnBD;EDoBC,yBAAA;AAgCpB;AA7BgB;;;;EAEI,sBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,cC/BD;EDgCC,eAAA;AAiCpB;AA/BgB;;EACI,UAAA;EACA,yBCpCD;EDqCC,iBAAA;AAkCpB;AAjCoB;;EACI,yBCtCT;AD0Ef;AAhCgB;EApCJ;;IAqCQ,WAAA;EAoClB;AACF","sourcesContent":["@import \"../../variables.scss\";\n\n.admin {\n    min-height: $main-height;\n    overflow: auto;\n    @include scrollbars(0.7em, $nitrocamBlue);\n    @media (max-width: $mobile) {\n        @include scrollbars(0em, $white);\n    }\n\n    .admin_sections {\n        @include flex(center, center, column, 2vh);\n        width: 100%;\n        margin: 1vh auto;\n        .admin_section {\n            @include flex(space-evenly, center, row, 10px);\n            flex-wrap: wrap;\n            width: 95vw;\n            border-radius: 5px;\n            .create_section,\n            .update_section {\n                @include flex(center, center, column, 10px);\n                height: 22vh;\n                width: 42vw;\n                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n                background-color: $nitrocamYellow;\n                border-radius: 5px;\n                padding: 10px;\n\n                h2 {\n                    margin: 0 auto;\n                    color: $nitrocamDarkBlue;\n                    text-transform: uppercase;\n                }\n\n                input,\n                select {\n                    box-sizing: border-box;\n                    height: 4.5vh;\n                    width: 80%;\n                    border-radius: 5px;\n                    border: none;\n                    padding: 0 5px;\n                    color: $nitrocamDarkBlue;\n                    font-size: 1rem;\n                }\n                button {\n                    width: 80%;\n                    background-color: $nitrocamDarkBlue;\n                    font-size: 1.1rem;\n                    &:hover {\n                        background-color: $nitrocamBlue;\n                    }\n                }\n\n                @media (max-width: $tablet) {\n                    width: 95vw;\n                }\n            }\n        }\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n$nitrocamDarkBlue: #151042;\n$nitrocamBlue: #3b00f8;\n$nitrocamRed: #ff161b;\n$nitrocamYellow: #ffe169;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 80vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex($justify: center, $align: center, $direction: row, $gap: 10px) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 60vh;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 1000px) {\n        width: 92vw;\n    }\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
